import InputField from 'bharat-ui/web/InputField';
import React, { ChangeEvent, useEffect, useState } from 'react';
import up from '../../../assets/images/up.svg';
import dow from '../../../assets/images/dow.svg';
import downArrowUnity from '../../../assets/images/downArrowUnity.svg';
import BottomSheet from 'bharat-ui/web/BottomSheet';
import Box from 'bharat-ui/web/Box';
import PaymentOptionsList from 'bharat-ui/web/PaymentOptionsList';
import Typography from 'bharat-ui/web/Typography';
import { makeStyles } from 'bharat-ui/web/Styles';
import { useSelectedLanguage } from 'Slices';
import InputPostPe from '../InputPostPe';
import UnityInputField from '../UnityInputField';

const useStyle = makeStyles(() => ({
	root: {
		marginTop: '16px',
		marginBottom: '16px',
		maxHeight: '720px',
	},
	mainContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-end',
		gap: '8px',
	},
	upiHandle: {
		color: '#2b80ff',
	},
	mainContainerUnity: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
	},
	upiHandleUnity: {
		color: '#FFCD1E',
	},
	handleUpi: {
		marginTop: '16px',
	},
}));

interface Props {
	upiHandleList: Array<unknown>;
	setUpiId: (vpa: string) => void;
	label?: string;
	setIsVpaValid: (isValid: boolean) => void;
	isShowUnityUi?: boolean;
}

const createData = (list: Array<unknown>) => {
	const data = [];
	for (let idx = 0; idx < list?.length; idx++) {
		data.push({
			id: list[idx],
			title: list[idx],
		});
	}
	return data;
};

const UpiHandleInput: React.FC<Props> = ({ upiHandleList, setUpiId, label, setIsVpaValid, isShowUnityUi }) => {
	const classes = useStyle();
	const language = useSelectedLanguage();
	const [close, setClose] = useState(false);
	const [upihandleData, setUpihandleData] = useState(Array<unknown>());
	const [vpa, setVpa] = useState('');
	const [vpaHandle, setVpaHandle] = useState((upiHandleList as any)[0]);
	const [vpaId, setVpaId] = useState('');
	const [isValidVpa, setIsValidVpa] = useState(true);
	const [isHandleChange, setIsHandleChange] = useState(false);

	useEffect(() => {
		setUpihandleData(createData(upiHandleList));
	}, []);

	useEffect(() => {
		if (vpaId.length > 0 && isHandleChange) {
			const regex = new RegExp(/^[\w.\-_]{3,}@[a-zA-Z]{3,}/);
			const isValid = label !== 'Others' ? /^[\w.-]+@[\w.-]+$/.test(vpaId) : regex.test(vpaId);
			setIsValidVpa(isValid);
			setIsVpaValid(isValid);
		}
	}, [isValidVpa, vpaId]);

	useEffect(() => {
		if (label !== 'Others') {
			setVpaId(vpa + vpaHandle);
			setUpiId(vpa + vpaHandle);
		} else {
			setVpaId(vpa);
			setUpiId(vpa);
		}
	}, [vpa, vpaHandle]);

	const handleOnclick = () => {
		setClose(true);
	};

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		event.preventDefault();
		setVpa(event.target.value);
		setIsHandleChange(true);
	};
	return (
		<>
			<div className={classes.root}>
				{isShowUnityUi ? (
					<UnityInputField
						label={language.ENTER_YOUR_UPI_ID_VPA}
						variant="outlined"
						endAdornment={
							label !== 'Others' ? (
								<Box className={classes.mainContainerUnity}>
									<Typography variant="Bold300" className={classes.upiHandleUnity}>
										{vpaHandle.length === 0 ? (upiHandleList as any)[0] : vpaHandle}
									</Typography>
									{upihandleData?.length > 1 && <img src={close ? '' : downArrowUnity} onClick={handleOnclick} />}
								</Box>
							) : null
						}
						onChange={handleChange}
						error={!isValidVpa}
						helperText={isValidVpa ? '' : language.INVALID_UPI_VPA}
						className="width-100"
					/>
				) : (
					<InputField
						label={language.ENTER_YOUR_UPI_ID_VPA}
						variant="outlined"
						endAdornment={
							label !== 'Others' ? (
								<Box className={classes.mainContainer}>
									<Typography variant="Bold300" className={classes.upiHandle}>
										{vpaHandle.length === 0 ? (upiHandleList as any)[0] : vpaHandle}
									</Typography>
									{upihandleData?.length > 1 && <img src={close ? up : dow} onClick={handleOnclick} />}
								</Box>
							) : null
						}
						onChange={handleChange}
						error={!isValidVpa}
						helperText={isValidVpa ? '' : language.INVALID_UPI_VPA}
						className="width-100"
					/>
				)}
			</div>
			{upihandleData?.length > 0 && (
				<BottomSheet
					visible={close}
					onClose={() => setClose(false)}
					heading={language.CHOOSE_UPI_HANLDE}
					rounded={true}
					roundRadius={30}
					fullscreen={false}
					showCloseButton={true}>
					<div className={classes.handleUpi}>
						<PaymentOptionsList
							list={upihandleData as any}
							onSelected={(list, id) => {
								console.log(language.VPA_SELECTED, list, id);
								setVpaHandle(list?.id);
								setClose(false);
							}}
						/>
					</div>
				</BottomSheet>
			)}
		</>
	);
};
export default UpiHandleInput;
